import { render, staticRenderFns } from "./EditGroups.vue?vue&type=template&id=82c0d836&"
import script from "./EditGroups.vue?vue&type=script&lang=js&"
export * from "./EditGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports